import * as React from 'react';
import { useSelector } from 'react-redux';
import { orgPayPeriodSelector } from '../../../redux/app/selectors/organization';

export const UpgradePlanBillingPeriod = () => {
  const [showHover, setShowHover] = React.useState(false);
  const payPeriod = useSelector(orgPayPeriodSelector);
  const isMonthly = payPeriod === 'monthly';
  const isAnnual = payPeriod === 'annual';
  const monthlyClassName = `${isMonthly ? 'bold-800' : ''} fsz-16 mr-10`;
  const annualClassName = `${isAnnual ? 'bold-800' : ''} fsz-16`;

  return (
    <div className="upgrade-billing-plan-section body pa-20">
      <div className="flex justify-between">
        <div className="item-header">
          <p className="orange bold-900">Billing Period</p>
        </div>
        <div
          className="flex"
          onMouseEnter={() => setShowHover(true)}
          onMouseLeave={() => setShowHover(false)}
        >
          <input className="mr-10" type="radio" value="Monthly" checked={isMonthly} disabled />
          <span className={monthlyClassName}>Monthly</span>
          <input className="mr-10" type="radio" value="Annual" checked={isAnnual} disabled />
          <span className={annualClassName}>Annual</span>
        </div>
        <span className={`hover-state ${showHover ? '' : 'hide'}`}>
          {`Your plan is currently an ${payPeriod} contract, and you can upgrade to the next tier
          of ${payPeriod} plan. Please contact our team at help@avochato.com for
          changes to your current contract.`}
        </span>
      </div>
    </div>
  );
}